import type { SVGProps } from 'react';
const SvgDrawerDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="m23.753 14.037-4.816-8.778A.5.5 0 0 0 18.499 5h-3.5v1h3.203l3.841 7h-6.544c-.275 0-.5.225-.5.5v.5c0 1.653-1.347 3-3 3s-3-1.347-3-3v-.5c0-.275-.225-.5-.5-.5H1.955l3.841-7h3.203V5h-3.5c-.181 0-.35.1-.438.259L.245 14.037A2.018 2.018 0 0 0-.002 15v6c0 1.103.897 2 2 2h20c1.103 0 2-.897 2-2v-6c0-.347-.091-.675-.247-.963zM22 21H2v-6h6.125A4.008 4.008 0 0 0 12 18a4.013 4.013 0 0 0 3.875-3H22v6z" />
    <path d="M8.456 7.044 7.04 8.46l4.25 4.25a.999.999 0 0 0 1.412 0l4.25-4.25-1.416-1.416-2.538 2.541V1.001h-2v8.584L8.454 7.044z" />
  </svg>
);
export default SvgDrawerDownload;
